import type { TImageCheckFormValues } from './types';

export const defaultBankValues: TImageCheckFormValues = {
  fileList: undefined,
  liveness: false,
  deepfake: false,
  iso: false,
  icao: false,
  mindigital: false,
  type: 'bank',
};

export const defaultContentValues: TImageCheckFormValues = {
  fileList: undefined,
  deepfake: true,
  type: 'content',
};
